/**
 * 观察者服务
 *@author kyy
 *@date 2021/4/14 14:04
 */
import { BehaviorSubject } from 'rxjs';

export class ObserverService {
  private static service: ObserverService;
  private userObserver: any = null; // 用户信息观察者
  private routeObserver: any = null;
  private showWhiteHeadObserver: any = null; // 显示白色页头观察者
  private isLoginObserver: any = null; // 是否登陆观察者

  public static getInstance(): ObserverService {
    if (ObserverService.service == null) {
      ObserverService.service = new ObserverService();
    }
    return ObserverService.service;
  }

  init() {
    this.userObserver = new BehaviorSubject(null);
    this.routeObserver = new BehaviorSubject(null);
    this.showWhiteHeadObserver = new BehaviorSubject(null);
    this.isLoginObserver = new BehaviorSubject(null);
  }

  getUserObserver() {
    return this.userObserver;
  }

  getRouteObserver() {
    return this.routeObserver;
  }

  getShowWhiteHeadObserver() {
    return this.showWhiteHeadObserver;
  }

  getIsLoginObserver() {
    return this.isLoginObserver;
  }
}
